module.exports = __webpack_public_path__ + "static/Image03@2x-efe861274b7873b7067642778db18395.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image03@2x.jpg
// module id = 896
// module chunks = 227233210825294 244429959259914